// extracted by css-extract-rspack-plugin
export default {"linkButton":"_1bpqVJG3Ppr02Dr7jTBiQ2"};